// extracted by mini-css-extract-plugin
export default {"konvaContextMenu":"KonvaContextMenu__konvaContextMenu___VVMSV"};